//
// Generated by @himenon/openapi-typescript-code-generator v0.27.4
//
// OpenApi : 3.0.0
//
//
import {
  Params$AdminAccountingUsageController_updatePlan,
  Response$AdminAccountingUsageController_updatePlan$Status$200,
  ResponseContentType$AdminAccountingUsageController_updatePlan,
} from '@api-client/generated/client';
import { useApiClientMutation } from '@hooks/useApiClientMutation';

export const useAdminAccountingUsageController_updatePlan = () =>
  useApiClientMutation<
    Params$AdminAccountingUsageController_updatePlan,
    Response$AdminAccountingUsageController_updatePlan$Status$200[ResponseContentType$AdminAccountingUsageController_updatePlan]
  >({ method: 'AdminAccountingUsageController_updatePlan' });
